import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlToPlaintext'
})
export class HtmlToPlaintextPipe implements PipeTransform {

  transform(value: any): any {

    let data = '';
    
    data = this.tagsEraser(value);
    // data = this.noEncoded(value);
    // console.log(data, value);
    return data
  }

  
  // public noEncoded(value){
  //   return value.split('&lt;').join('<').split('&gt;').join('>');
  // }
  public tagsEraser(value){
    return value ? String(value).replace(/<[^>]+>/gm, '') : '';
  }

}
//Xa:Qué pasaría si escribieran los < algo >, se borrarian?
//resp Xa: no ocurre nada si viene desde admin pues vendran en encode, así que pueden poner los <> sin riesgos
// se usaría [innerHTML]=""
// https://stackoverflow.com/questions/17289448/angularjs-to-output-plain-text-instead-of-html